<template>
      <card>
        <list
          :columns="columns"
          :modalCreate="modalCreate"
          :removeLink="removeLink"
          :cardLink="cardLink"
          :isUpdate="true"
          :isAdd="true"
          :itemLink="itemLink"
          :dateFilter="dateFilter"
          :setLink="setLink"
          :fields="fields"
          :filters="filters"
          :staticFilters="staticFilters"
          :searchDisable="false"
          @change="change"
          @changeFunction="changeFunction"
          v-model="val"
        />
      </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
         dateFilter:[
            {
              key:'from_at',
              title:'Начало даты',
            },
            {
              key:'till_at',
              title:'Конец даты',
            },
        ],
         filters: [
        {
          key: "status_order",
          title: "Статус заказа",
          titleKey:'title'
        },
        {
          key: "dealer",
          title: "Бизнес",
          titleKey:'llc_name'
        },
      ],
            staticFilters: [
       
        {
          title: "Статус оплаты",
          key: "is_paid",
          default: null,
          items: [
            { 
                id:null,
                title:"Показать все"
            },
            {
              id: "2",
              title: "Оплачен",
            },
            {
              id: "1",
              title: "Не оплачен",
            }
          ],
        },
    
      
      ],
      val: [],
      modalCreate: "order",
      fields: [
     
            {
              col:' col-12 col-md-12',
              key: "shop",
              label: "Магазин",
              type: "select",
              selectKey: "name",
              modal: "my_shop",
            },
            {
              col:' col-12 col-md-12',
              key: "purchases",
              label: "Товары",
              input: "input_data",
              type: "selects",
              selectKey: "display_name",
              modal: "option_key",
            },
        
        ],
      /** APIs */
      removeLink: "",
      cardLink: "item_order",
      itemLink: "my-orders",
      setLink: "my-orders",
      columns: [
        {
          key: "id",
          title: "ID",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          sortBy:'id'
        },
        {
          key: "status",
          object: "title",
          title: "Статус",
          disableLink:true
        },
        {
          key: "created_at",
          title: "Создан",
          dateTimeFormat: true,
        },
        {
          key: "dealer",
          object: "phone",
          title: "Заказчик",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
 
        {
          key: "price",
          title: "Стоимость заказа",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "is_paid",
          title: "Оплачен",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          detail: true,
          // remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
